import React, { useContext } from 'react'
import TadobaContext from '../Context/TadobaContext'
import LazyImage from '../LazyImage'
const Upload_Setup = (props) => {
    const api = useContext(TadobaContext)
    return (
        <div className="Upload_Area">
            <div className='Setting_User'>
                <div className="Setting_User_Header">
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                        <img style={{ cursor: "pointer" }} src={require('../../Assets/Icons/left.png')} onClick={() => {
                            props.setUploadview(false)
                        }} alt="" />
                        <span>Uploaded Images({api.images.length})</span>
                    </div>
                </div>
            </div>
            <div className='Images_View' style={{ height: "62vh" }}>
                {api.images.map((value, key) => {
                    return (
                        <div className='Individual_Image'>
                            <LazyImage src={value.image} placeholderSrc={require("../../Assets/Icons/temp_img.png")} />
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default Upload_Setup